(() => {
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');

  const init = (root) => {
    if (root.dataset.drvTrowsReady) return;
    root.dataset.drvTrowsReady = '1';
    const list = root.querySelector('[data-drv-trows-pills]');
    const pills = Array.from(root.querySelectorAll('[data-drv-trows-pill]'));
    if (!list || !pills.length || !('IntersectionObserver' in window)) return;

    const byId = new Map();
    pills.forEach((pill) => {
      const id = decodeURIComponent(pill.hash.slice(1));
      const row = id && document.getElementById(id);
      if (row && root.contains(row)) byId.set(row, pill);
    });

    const show = (pill) => {
      pills.forEach((p) => {
        if (p === pill) p.setAttribute('aria-current', 'true');
        else p.removeAttribute('aria-current');
      });
      if (list.scrollWidth > list.clientWidth) {
        const pr = pill.getBoundingClientRect();
        const lr = list.getBoundingClientRect();
        const left = list.scrollLeft + pr.left - lr.left - (lr.width - pr.width) / 2;
        list.scrollTo({ left: Math.max(0, left), behavior: reduced.matches ? 'auto' : 'smooth' });
      }
    };

    let heldUntil = 0;
    pills.forEach((pill) => {
      pill.addEventListener('click', () => {
        heldUntil = Date.now() + 1200;
        show(pill);
      });
    });

    const visible = new Set();
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) visible.add(entry.target);
          else visible.delete(entry.target);
        });
        if (Date.now() < heldUntil) return;
        const rows = Array.from(byId.keys()).filter((row) => visible.has(row));
        if (rows.length) show(byId.get(rows[rows.length - 1]));
      },
      { rootMargin: '-35% 0px -55% 0px' }
    );
    byId.forEach((_, row) => io.observe(row));
  };

  const start = (scope) => scope.querySelectorAll('[data-drv-trows]').forEach(init);
  start(document);
  document.addEventListener('shopify:section:load', (event) => start(event.target));
})();
